<hlm-toaster position="top-right" expand closeButton richColors />
<app-main-layout>
  <router-outlet></router-outlet>
</app-main-layout>

<app-sidepanel>
  <app-sidepanel-header>
    <span class="component-medium-semibold">{{ sidepanelTitle() }}</span>
    <div class="gap-xxs flex">
      @for (chip of sidepanelChips(); track $index) {
        <app-chip [label]="chip.label" [variant]="chip.variant" />
      }
    </div>
  </app-sidepanel-header>
  <app-sidepanel-content>
    @if (sidepanelDescription()) {
      <app-sidepanel-description [value]="sidepanelDescription()!" />
    }
    <ng-template #sidepanelContainer />
  </app-sidepanel-content>
  <app-sidepanel-footer>
    <ng-template #footerSidepanelContainer ngProjectAs="footer" />
  </app-sidepanel-footer>
</app-sidepanel>
